import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MenuItemBaseComponent } from '../menu-item-base/menu-item-base.component';
import { ConfigService } from '../../../../core/services/config.service';
import { MenuItemControlButtonComponent } from "./menu-item-control-button/menu-item-control-button.component";
import { ItemWithOptionUpdateComponent } from "../item-with-option-update/item-with-option-update.component";
import { PricePipe } from "../../../../core/pipes/price.pipe";
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        NgbTooltipModule,
        TranslocoCurrencyPipe,
        PricePipe,
        MenuItemControlButtonComponent,
        ItemWithOptionUpdateComponent]
})
export class MenuItemComponent extends MenuItemBaseComponent implements OnInit {

    @Input() restaurantCssClass: string = ''

    constructor(public translate: TranslocoService, public configService: ConfigService) {
        super(translate, configService)
    }

    ngOnInit(): void {
        super.ngOnInit()
    }

}
